import React from 'react';
import styled from 'styled-components';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import MainBody from '../../components/layout/MainBody';
import Section from '../../components/layout/Section';
import SubMenu from '../../components/UI/SubMenu';
import OrderList from './OrderList';
import OrderDetail from './OrderDetail';
import MyInfo from './MyInfo';

const categories = ['주문/배송 내역', '개인정보수정'];

export default function MyPage() {
	const location = useLocation();
	const navigate = useNavigate();

	const [selectedMenu, setSelectedMenu] = React.useState(
		location.pathname.includes('info') ? 1 : 0
	);
	
	const onClickMenu = (index) => {
		setSelectedMenu(index);

		if(index === 0) {
			navigate('/my/orders');
		} else if(index === 1) {
			navigate('/my/info');
		}
	}

	return (
		<MainBody>
			<Section>
				<SubMenu
					categories={ categories }
					selectedMenu={ selectedMenu }
					setSelectedMenu={ onClickMenu }
				/>
				<Outlet />
			</Section>
		</MainBody>
	);
}